import AuthorizedRoute from './Authorized';

export default AuthorizedRoute;
